import { FtlTrailerType } from "../../../../../../../api/types/generated-types";

/** @deprecated this is to satisfy old graphql code. Do not continue to use this */
export const ftlTrailerTypeList = Object.values(FtlTrailerType);
